import { api } from '../api-client.config';
import { PageType } from 'src/types/domain.types';
import { useQuery } from '@tanstack/react-query';

const getPages = (): Promise<{ pages: PageType[] }> => api.get(`/pages`);

export const useGetPagesQuery = () => {
  return useQuery({
    queryKey: ['pages'],
    queryFn: () => getPages(),
    select: (data) => data.pages,
  });
};
